// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"Q--z"};